import { Link } from '@tanstack/react-router'
import { UploadIcon } from 'lucide-react'

import { Button } from '@/components/button/button'

import { cn } from '@/lib/utils'

export const DocumentUploadButton = () => {
  return (
    <Link to="/upload-document">
      <Button variant="secondary" asChild>
        <div>
          <UploadIcon className={cn('mr-2')} size={17} />
          <span>Document (i.e. I-797) Upload</span>
        </div>
      </Button>
    </Link>
  )
}
